"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_INFO_SIZE = exports.TEXT_INFO_SEGMENT = exports.TEXT_INFO_KIND = exports.TEXT_INFO_HEADING_LEVEL = exports.TEXT_INFO_FONT_WEIGHT = exports.TEXT_INFO_DISPLAY = exports.TEXT_INFO_DECORATION = exports.TEXT_INFO_OPACITY = exports.TEXT_INFO_COLOR = exports.TEXT_INFO_BORDER = exports.TEXT_INFO_ALIGN = void 0;
/* eslint-disable prettier/prettier  */
// React
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = __importDefault(require("styled-components"));
// Components
const next12_utils_enums_segment_1 = require("@gcloud-npm/next12.utils.enums.segment");
Object.defineProperty(exports, "TEXT_INFO_SEGMENT", { enumerable: true, get: function () { return next12_utils_enums_segment_1.SEGMENT; } });
const next12_utils_enums_colors_1 = __importStar(require("@gcloud-npm/next12.utils.enums.colors"));
Object.defineProperty(exports, "TEXT_INFO_COLOR", { enumerable: true, get: function () { return next12_utils_enums_colors_1.COLOR_DICTIONARY; } });
Object.defineProperty(exports, "TEXT_INFO_OPACITY", { enumerable: true, get: function () { return next12_utils_enums_colors_1.OPACITY; } });
// Enums
const enums_1 = require("./enums");
Object.defineProperty(exports, "TEXT_INFO_ALIGN", { enumerable: true, get: function () { return enums_1.TEXT_INFO_ALIGN; } });
Object.defineProperty(exports, "TEXT_INFO_BORDER", { enumerable: true, get: function () { return enums_1.TEXT_INFO_BORDER; } });
Object.defineProperty(exports, "TEXT_INFO_DECORATION", { enumerable: true, get: function () { return enums_1.TEXT_INFO_DECORATION; } });
Object.defineProperty(exports, "TEXT_INFO_DISPLAY", { enumerable: true, get: function () { return enums_1.TEXT_INFO_DISPLAY; } });
Object.defineProperty(exports, "TEXT_INFO_FONT_WEIGHT", { enumerable: true, get: function () { return enums_1.TEXT_INFO_FONT_WEIGHT; } });
Object.defineProperty(exports, "TEXT_INFO_HEADING_LEVEL", { enumerable: true, get: function () { return enums_1.TEXT_INFO_HEADING_LEVEL; } });
Object.defineProperty(exports, "TEXT_INFO_KIND", { enumerable: true, get: function () { return enums_1.TEXT_INFO_KIND; } });
Object.defineProperty(exports, "TEXT_INFO_SIZE", { enumerable: true, get: function () { return enums_1.TEXT_INFO_SIZE; } });
// Utils
const utils_1 = require("./utils");
const StyledTextInfo = styled_components_1.default.p.attrs((props) => {
    return {
        "data-cy": `${props.cyData || ""}`,
    };
}) `
  ${(props) => (props.textColor ? `color:${props.textColor};` : "")}
  ${(props) => props.backgroundColor && props.backgroundColor !== "transparent"
    ? `background-color:${props.backgroundColor};`
    : ""}
    ${(props) => props.border && props.border === "rounded"
    ? `border-radius:10px; padding: 3px;`
    : ""}
    ${(props) => props.decoration ? `text-decoration:${props.decoration};` : ""}
`;
/**
 * @name TextInfo
 * @description atomic component
 * @see {@link https://bit.dev/gerenciatd/unifiedcomponents/text-info}
 * @param {any} props
 * @returns {React.FC}
 */
const COMPONENT_NAME = "TextInfo";
const TextInfo = (props) => {
    const { className, segment: segmentProp, kind, text, color, opacity, border, decoration, backgroundColor, cyData, level, custoObjectInfo } = props, restProps = __rest(props, ["className", "segment", "kind", "text", "color", "opacity", "border", "decoration", "backgroundColor", "cyData", "level", "custoObjectInfo"]);
    let componentClassName = "text-info text-info-n";
    if (className) {
        componentClassName = `${componentClassName} ${className}`;
    }
    const segment = (0, next12_utils_enums_segment_1.getCssSegment)(segmentProp);
    const colorOpacity = (0, next12_utils_enums_colors_1.default)(color, opacity, segment);
    const bgColorOpacity = (0, next12_utils_enums_colors_1.default)(backgroundColor, opacity, segment);
    const normalizedKind = (0, utils_1.getProperKind)(kind);
    if (!normalizedKind) {
        return null;
    }
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        componentClassName = `${componentClassName} custo-editable`;
    }
    return (react_1.default.createElement(StyledTextInfo, { as: normalizedKind === enums_1.TEXT_INFO_KIND.HEADING
            ? `${normalizedKind}${level || 1}`
            : normalizedKind, textColor: colorOpacity, backgroundColor: bgColorOpacity, border: border, decoration: decoration, className: `${componentClassName} ${(0, utils_1.extendTextInfoClassNames)(Object.assign(Object.assign({}, restProps), { segment }))}`, dangerouslySetInnerHTML: { __html: text }, onClick: editModal, cydata: cyData }));
};
TextInfo.propTypes = {
    className: prop_types_1.default.string,
    kind: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_KIND)),
    ]),
    level: prop_types_1.default.oneOfType([
        prop_types_1.default.number,
        prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_HEADING_LEVEL)),
    ]),
    text: prop_types_1.default.string.isRequired,
    color: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(next12_utils_enums_colors_1.COLOR_DICTIONARY)),
    ]),
    size: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_SIZE)),
    fontType: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_FONT_WEIGHT)),
    align: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_ALIGN)),
    display: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_DISPLAY)),
    backgroundColor: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(next12_utils_enums_colors_1.COLOR_DICTIONARY)),
    ]),
    decoration: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_DECORATION)),
    border: prop_types_1.default.oneOf(Object.values(enums_1.TEXT_INFO_BORDER)),
    segment: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(next12_utils_enums_segment_1.SEGMENT)),
    ]),
    opacity: prop_types_1.default.oneOf(Object.values(next12_utils_enums_colors_1.OPACITY)),
    cyData: prop_types_1.default.string,
    custoInfo: prop_types_1.default.shape({
        componentId: prop_types_1.default.string,
        componentInstance: prop_types_1.default.string,
        editFunction: prop_types_1.default.func,
    }),
};
TextInfo.defaultProps = {
    kind: enums_1.TEXT_INFO_KIND.SPAN,
    size: enums_1.TEXT_INFO_SIZE.CAPTION2,
    color: next12_utils_enums_colors_1.COLOR_DICTIONARY.BLACK,
    fontType: enums_1.TEXT_INFO_FONT_WEIGHT.REGULAR,
    cyData: "",
    className: "",
    custoInfo: null,
    align: enums_1.TEXT_INFO_ALIGN.LEFT,
    display: enums_1.TEXT_INFO_DISPLAY.BLOCK,
    backgroundColor: next12_utils_enums_colors_1.COLOR_DICTIONARY.TRANSPARENT,
    border: enums_1.TEXT_INFO_BORDER.NONE,
    opacity: next12_utils_enums_colors_1.OPACITY[100],
};
exports.default = TextInfo;
//# sourceMappingURL=index.js.map